module.exports = __webpack_public_path__ + "img/116.90808c71.jpg";